import React from 'react'
import styles from '../containers/launchPage.module.scss'

export type GreetingCardPreview = {
  previewUrl: string
  isHorizontal: boolean
}

type GreetingCardCarouselProps = {
  cards: ReadonlyArray<GreetingCardPreview>
  cardWidth?: number
  cardHeight?: number
  gap?: number
}

export const GreetingCardCarousel: React.FC<GreetingCardCarouselProps> = ({
  cards,
  cardWidth = 110,
  cardHeight = 154,
  gap = 12,
}) => {
  const horizontalCardHeight = Math.round(cardHeight * 0.7)
  const horizontalCardWidth = Math.round((horizontalCardHeight * 7) / 5)
  const carouselCards = [...cards, ...cards]

  return (
    <div
      className={styles.catalogCarouselOuter}
      aria-label="Featured catalog card designs"
    >
      <div className={styles.catalogCarouselInner}>
        {carouselCards.map((card, index) => {
          const width = card.isHorizontal ? horizontalCardWidth : cardWidth
          const height = card.isHorizontal ? horizontalCardHeight : cardHeight

          return (
            <div
              key={`${card.previewUrl}-${index}`}
              className={styles.catalogCardPreview}
              style={{
                width,
                height,
                marginRight: index === carouselCards.length - 1 ? 0 : gap,
              }}
            >
              <img src={card.previewUrl} alt="Catalog card design preview" />
            </div>
          )
        })}
      </div>
    </div>
  )
}
